import { LANDING_FAQS } from './constants.jsx';

export default function FAQSection() {
  return (
    <div className="max-w-3xl mx-auto mb-28 relative z-10 text-left">
      <div className="mb-8">
        <div className="ed-eyebrow mb-3">FAQ</div>
        <h2 className="ed-display text-3xl md:text-4xl">Häufig gestellte Fragen.</h2>
      </div>
      <div>
        {LANDING_FAQS.map(({ q, a }) => (
          <div key={q} className="ed-faq">
            <div className="grid md:grid-cols-[1fr_1.4fr] gap-3 md:gap-10">
              <h3 className="ed-faq-q text-lg md:text-xl">{q}</h3>
              <p className="ed-muted leading-relaxed">{a}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
